import { Viewports as t } from "@ddg-frontend/fe-essentials";
const o = (e) => {
  switch (e) {
    default:
      return {
        // XS: 360, //! Existe mas não é lido
        S: 480,
        M: 768,
        L: 960,
        XL: 1200,
        XXL: 1600
      };
  }
}, s = (e) => {
  switch (e) {
    case "moche":
      return "imageM";
    default:
      return "imageL";
  }
}, a = (e) => {
  switch (e) {
    case "moche":
      return t.M;
    default:
      return t.L;
  }
}, i = (e) => {
  switch (e) {
    default:
      return "imageXS";
  }
};
export {
  s as getBreakDesktop,
  i as getBreakMobile,
  a as getBreakSizeDesktop,
  o as getSiteBreakpoints
};
